module.exports = __webpack_public_path__ + "img/project-objective_edit.6057f203.png";